import { Nullable } from '@/model/common';
import { InferType, number, object } from 'yup';
import { currencyIdSchema, safeString } from './common';

export const portalInternalTransferSchema = () =>
    object({
        transferType: object({ label: safeString(), value: safeString() }).required(
            'Please select a internal transfer type.'
        ),
        counterPartId: object({ label: safeString(), value: number() }).test(
            'valueNotUndefined',
            `Please select an counterpart.`,
            (counterpart) => !!counterpart.value
        ),
        currencyId: currencyIdSchema('Currency cannot be empty!'),
        // amount value must be greater than 0
        amount: safeString().min(0, 'Amount must be more than 0').required('Amount cannot be empty!'),
        requestDescription: safeString(),
        contraCurrencyId: object({ label: safeString(), value: number() })
            .test('valueNotUndefined', `Please select a contra currency.`, (code) => !!code.value)
            .required('Please select a contra currency.')
    });

export type PortalInternalTransferFormValues = InferType<ReturnType<typeof portalInternalTransferSchema>>;
export type PortalInternalTransferFormInput = Nullable<PortalInternalTransferFormValues>;
